/* Copyright (c) 2024 MOCA Systems, Inc. All rights reserved. */

import { NgModule } from '@angular/core';
import { MultiPanelItemDirective } from './multi-panel-item/multi-panel-item.directive';
import { MultiPanelHeaderComponent } from './multi-panel-header/multi-panel-header.component';
import { MultiPanelContentComponent } from './multi-panel-content/multi-panel-content.component';
import { MultiPanelComponent } from './multi-panel.component/multi-panel.component';
import { MultiPanelService } from './multi-panel.service';

//https://v17.angular.io/guide/standalone-components#standalone-components-for-library-authors
// for "external use", this is the public import

@NgModule({
	imports: [
		MultiPanelComponent,
		MultiPanelItemDirective,
		MultiPanelHeaderComponent,
		MultiPanelContentComponent,
	],
	exports: [
		MultiPanelComponent,
		MultiPanelItemDirective,
		MultiPanelHeaderComponent,
		MultiPanelContentComponent,
	],
})
export class MultiPanelModule {}

@NgModule({
	imports: [MultiPanelModule],
	providers: [MultiPanelService, MultiPanelItemDirective],
})
/** For use in spec files */
export class TestMultiPanelModule {}
